<script setup>
// Liga/desliga com o rotulo em linguagem de cliente; trancado mostra o motivo.
defineProps({
  rotulo: { type: String, required: true },
  ajuda: { type: String, default: '' },
  trancado: { type: String, default: '' },
});
const ligado = defineModel({ type: Boolean, default: false });
</script>

<template>
  <label
    class="flex items-start justify-between gap-4 p-3 rounded-lg border border-n-weak"
    :class="trancado ? 'opacity-60' : 'cursor-pointer'"
  >
    <span class="flex flex-col gap-0.5">
      <span class="text-sm text-n-slate-12">{{ rotulo }}</span>
      <span v-if="ajuda" class="text-xs text-n-slate-11">{{ ajuda }}</span>
      <span v-if="trancado" class="text-xs font-medium text-n-amber-11">
        {{ trancado }}
      </span>
    </span>
    <input
      v-model="ligado"
      type="checkbox"
      class="mt-1 size-4"
      :disabled="!!trancado"
    />
  </label>
</template>
